import React from 'react';
import PropTypes from 'prop-types';
import './BulletSection.css';
import Button from '../Button/Button'; // Reusing your existing Button

const BulletSection = ({
  title,
  heading,
  image,
  services = [],
  button,
  reverse = false,
  link
}) => {
  const hasContent = title || heading || services.length || image;

  if (!hasContent) return <p>No data found.</p>;

  return (
<div className={`bullet-section-container ${reverse ? 'reverse' : ''}`}>
  {image && (
    <div className="bullet-section-image">
      <img src={image} alt={title} loading="lazy" />
    </div>
  )}

  <div className={`bullet-section-content ${reverse ? 'reverse-bg' : ''}`}>
    {title && <h5 className="bullet-section-subtitle">{title}</h5>}
    {heading && <h2 className="bullet-section-title">{heading}</h2>}
    {services.length > 0 && (
      <ul className="bullet-section-list">
        {services.map((point, index) => (
          <li key={index}>{point}</li>
        ))}
      </ul>
    )}
    {button && <Button text={button} link={link} reverse={reverse} />}

  </div>
</div>

  );
};

BulletSection.propTypes = {
  title: PropTypes.string,
  heading: PropTypes.string,
  image: PropTypes.string,
  services: PropTypes.arrayOf(PropTypes.string),
  button: PropTypes.string,
  reverse: PropTypes.bool,
    link: PropTypes.string,
};

export default BulletSection;
